import React, { useState, useEffect } from "react"
import { Row, Card, CardBody, Spinner } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { useSelector } from "react-redux"
import axios from "axios"
import config from "config/config"

const ProfileViewsChart = ({ syncKey }) => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const mode = useSelector(state => state.Layout.layoutMode)
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const userData = useSelector(state => state.Login.userData)

  const [isLoading, setIsLoading] = useState(false)
  const [chartData, setChartData] = useState({
    options: {
      colors: ["#2990DF"],
      chart: {
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: [], // Days
      },
      yaxis: {
        title: {
          text: "Profile Views",
        },
      },
    },
    series: [
      {
        name: "Profile Views",
        data: [], // Daily profile views
      },
    ],
  })

  const fetchDailyData = async (force = false) => {
    try {
      setIsLoading(true)

      const organizationIds = isConsolidatedView
        ? organizations.map(org => org.Organization.id)
        : [activeOrganization.id]

      const resp = await axios.get(
        `${config.backendUrl}/instagram/dashboard/profile-views-chart`,
        {
          params: { organizationIds: organizationIds.join(","), force },
          headers: { Authorization: `Bearer ${userData.token}` },
          skipLoader: true,
        },
      )

      setChartData({
        options: {
          ...chartData.options,
          xaxis: {
            ...chartData.options.xaxis,
            categories: resp.data.categories,
          },
        },
        series: resp.data.series,
      })
    } catch (err) {
      console.error(
        "Error fetching Instagram insights:",
        err.response?.data || err.message,
      )
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchDailyData()
  }, [activeOrganization, isConsolidatedView, organizations])

  useEffect(() => {
    if (syncKey) fetchDailyData(true)
  }, [syncKey])

  return (
    <Card style={{ minHeight: "350px" }} className="br">
      {isLoading ? (
        <div
          style={{
            minHeight: "350px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner
            size="lg"
            style={{
              color: mode === "dark" ? "#fff" : "#2990DF",
            }}
          />
        </div>
      ) : (
        <CardBody>
          <h4 className="card-title mb-4">
            Instagram Profile Views (Last 30 Days)
          </h4>
          <Row>
            {/* Chart */}
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="line"
              height="290"
            />
          </Row>
        </CardBody>
      )}
    </Card>
  )
}

export default ProfileViewsChart